export default (Alpine) => {
	
	Alpine.directive('link', (el, { expression }) => {

		$(el).on('click', () => {
	
			window.location = expression;
	
		});

	});

};